import createElementChangeListener from "../../elementChangeListener";

function loadStyle(style) {
    style.setAttribute("rel", "stylesheet");
}

export default function loadLazyScripts() {
    const selector = "[rel=lazy-stylesheet]";
    createElementChangeListener(selector, loadStyle);
}
